import type { SxProps } from '@mui/system';

/**
 * Styling used for Action's Button
 * @type {SxProps}
 */
export const buttonStyling: SxProps = {
  width: { xs: '11.25rem', md: '8.25rem' },
  height: { xs: '3rem' },
  wordWrap: 'normal',
  wordBreak: 'normal',
};

export const iconLargerStyling: SxProps = {
  '&&': {
    width: { xs: '2rem' },
    height: { xs: '2rem' },
    color: 'text.dark',
  },
};
/**
 * Styling used for Action's Icons
 * @type {SxProps}
 * @property {&&} - specific styling for SVG, because they are being overwritten by MUI ButtonBase
 */
export const iconStyling: SxProps = {
  '&&': {
    width: { xs: '1.5rem' },
    height: { xs: '1.5rem' },
    color: 'text.dark',
  },
};

export const inlineButtonStyle: SxProps = {
  gridColumn: { xs: 'span 3', md: '2 / span 1' },
  py: 0,
  mb: 2,
  gridRow: { xs: '6', md: '5 / span 1' },
  display: { md: 'none' },
  backgroundColor: 'grey.light',
  border: '1px solid',
  borderColor: 'grey.main',
  width: '100%',
  minHeight: '38px',
  height: '38px',
};

export const addToBasketListViewStyleOverrides: SxProps = {
  backgroundColor: { xs: 'grey.light', md: 'transparent' },
  border: { xs: '1px solid', md: 'none' },
  '&:hover': { backgroundColor: 'grey.light' },
};
export const addToBasketStyleOverridesGalleryView: SxProps = {
  p: 0,
  width: '36px',
  height: '36px',
  minHeight: '36px',
  backgroundColor: 'grey.light',
  border: '1px solid',
  borderColor: 'grey.main',
};
